import { PropsWithChildren } from 'react';

import './ImageSection.scss';
import { ModuleStatus } from 'types/module';

type Props = {
  status: ModuleStatus;
  imageUrl: string;
  isAdmin?: boolean;
};

export const ImageSection = ({ status, imageUrl, isAdmin, children }: PropsWithChildren<Props>) => {
  return (
    <div
      className='module-image'
      style={{
        backgroundImage:
          status === 'ComingSoon' && !isAdmin
            ? `linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${imageUrl})`
            : `url(${imageUrl})`,
      }}
    >
      <div className='module-tag'>{children}</div>
    </div>
  );
};
